import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import WComponent from "../../../../../../../common/WComponent";
import "../../../../afs-walkthrough.css";

class GLSearchPanel extends WComponent {
	state = {
		search: this.props.initialSearch || "",
		expandedRow: null,
		reclassifySearch: "",
		selectedTarget: null, // { canonical_code, label }
		reclassified: {},
	};

	render() {
	let { transactions, chartOfAccounts, onReclassify, onClose, onBack } = this.props;
	let { search, expandedRow, reclassifySearch, selectedTarget, reclassified } = this.state;

	let allTx = transactions || [];

	let filtered = (function () {
		let q = (search || "").trim().toLowerCase();
		if (!q) return allTx.slice(0, 50);

		return allTx.filter(function (tx) {
			let desc = (tx.description || "").toLowerCase();
			let cls = (tx.canonical_label || tx.classification || "").toLowerCase();
			let amt = String(Math.abs(parseFloat(tx.amount) || 0));
			let date = tx.date || "";
			return desc.includes(q) || cls.includes(q) || amt.includes(q) || date.includes(q);
		}).slice(0, 50);
	})();

	let taxonomyOptions = (function () {
		return (chartOfAccounts || []).filter(function (acct) {
			return acct.canonical_code;
		}).map(function (acct) {
			return {
				canonical_code: acct.canonical_code,
				label: acct.accountName || acct.display_name || acct.accountDescription || acct.description || acct.canonical_code,
				gifi_code: acct.gifi_code,
			};
		});
	})();

	let filteredTaxonomy = (function () {
		let q = (reclassifySearch || "").trim().toLowerCase();
		if (!q) return taxonomyOptions.slice(0, 10);
		return taxonomyOptions.filter(function (opt) {
			return opt.label.toLowerCase().includes(q) || (opt.canonical_code || "").toLowerCase().includes(q);
		}).slice(0, 10);
	})();

	let handleReclassify = (tx, targetCode, targetLabel, scope) => {
		if (onReclassify) {
			onReclassify({
				transaction_id: tx.id || null,
				transaction_description: tx.description,
				to_canonical_code: targetCode,
				scope: scope,
			});
		}
		if (scope === "single") {
			this.setState(function (prev) { return { reclassified: { ...prev.reclassified, [tx.id || tx.description + "_" + tx.date]: targetLabel } }; });
		} else {
			// Mark all matching description rows as reclassified
			let desc = tx.description;
			let updates = {};
			for (let t of allTx) {
				if (t.description === desc) updates[t.id || t.description + "_" + t.date] = targetLabel;
			}
			this.setState(function (prev) { return { reclassified: { ...prev.reclassified, ...updates } }; });
		}
		this.update({ expandedRow: null });
		this.update({ reclassifySearch: "" });
		this.update({ selectedTarget: null });
	};

	let fmtAmount = function (val) {
		let n = parseFloat(val) || 0;
		let abs = Math.abs(n).toLocaleString("en-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
		return n < 0 ? "-$" + abs : "$" + abs;
	};

	let fmtDate = function (d) {
		if (!d) return "—";
		try {
			let parts = String(d).split("T")[0].split("-");
			let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			return months[parseInt(parts[1], 10) - 1] + " " + parseInt(parts[2], 10) + ", " + parts[0];
		} catch (e) { return String(d); }
	};

	return (
		<div className="afs-gl-search">
			<div className="afs-gl-search__header">
				<div className="afs-gl-search__header-title">
					{onBack && (
						<button className="afs-gl-search__back" onClick={onBack} title="Back to Trial Balance"><Icon.ArrowLeft size={16} /></button>
					)}
					<Icon.Search size={16} />
					<span>GL Search</span>
				</div>
				<button className="afs-gl-search__close" onClick={onClose}><Icon.X size={16} /></button>
			</div>

			<div className="afs-gl-search__search-bar">
				<input
					className="afs-gl-search__search-input"
					type="text"
					placeholder="Search by description, account, amount, date..."
					value={search}
					onChange={(e) => { this.update({ search: e.target.value }); }}
					autoFocus
				/>
			</div>

			<div className="afs-gl-search__count">
				{search ? "Showing " + filtered.length + " of " + allTx.length + " transactions" : "Type to search " + allTx.length + " transactions"}
			</div>

			<div className="afs-gl-search__list">
				{filtered.map(function (tx, i) {
					let isExpanded = expandedRow === (tx.id || i);
					let txKey = tx.id || tx.description + "_" + tx.date;
					let wasReclassified = reclassified[txKey];
					let currentLabel = tx.canonical_label || tx.classification || "Unclassified";

					return (
						<div key={tx.id || i} className={clsx("afs-gl-search__tx", wasReclassified && "afs-gl-search__tx--reclassified")}>
							<div className="afs-gl-search__tx-main">
								<div className="afs-gl-search__tx-left">
									<div className="afs-gl-search__tx-desc">{tx.description || "—"}</div>
									<div className="afs-gl-search__tx-meta">
										<span>{fmtDate(tx.date)}</span>
										<span className="afs-gl-search__tx-separator">&middot;</span>
										<span className={clsx("afs-gl-search__tx-current-class", wasReclassified && "afs-gl-search__tx-current-class--changed")}>
											{wasReclassified || currentLabel}
										</span>
										{wasReclassified && <Icon.CheckCircle size={12} color="#2e7d32" />}
									</div>
								</div>
								<div className="afs-gl-search__tx-right">
									<span className={clsx("afs-gl-search__tx-amount", parseFloat(tx.amount) < 0 && "afs-gl-search__tx-amount--negative")}>{fmtAmount(tx.amount)}</span>
									{!wasReclassified && (
										<button className="afs-gl-search__tx-reclassify-btn" onClick={() => {
											this.update({ expandedRow: isExpanded ? null : (tx.id || i) });
											this.update({ reclassifySearch: "" });
										}}>
											<Icon.RefreshCw size={12} /> Reclassify
										</button>
									)}
								</div>
							</div>

							{isExpanded && (
								<div className="afs-gl-search__tx-expand">
									<input
										className="afs-gl-search__reclassify-input"
										type="text"
										placeholder={"Search " + taxonomyOptions.length + " accounts..."}
										value={reclassifySearch}
										onChange={(e) => { this.update({ reclassifySearch: e.target.value }); }}
										autoFocus
									/>
									{!selectedTarget ? (
										<div className="afs-gl-search__reclassify-options">
											{filteredTaxonomy.map(function (opt) {
												return (
													<button key={opt.canonical_code} className="afs-gl-search__reclassify-option" onClick={() => { this.update({ selectedTarget: opt }); }}>
														<span className="afs-gl-search__reclassify-option-name">{opt.label}</span>
														{opt.gifi_code && <span className="afs-gl-search__reclassify-option-gifi">GIFI {opt.gifi_code}</span>}
													</button>
												);
											})}
											{filteredTaxonomy.length === 0 && <div className="afs-gl-search__reclassify-empty">No accounts match "{reclassifySearch}"</div>}
										</div>
									) : (
										<div className="afs-gl-search__reclassify-confirm">
											<div className="afs-gl-search__reclassify-confirm-label">
												Reclassify to: <strong>{selectedTarget.label}</strong>
											</div>
											<div className="afs-gl-search__reclassify-confirm-actions">
												<button className="afs-gl-search__reclassify-confirm-btn afs-gl-search__reclassify-confirm-btn--single" onClick={function () { handleReclassify(tx, selectedTarget.canonical_code, selectedTarget.label, "single"); }}>
													This one only
												</button>
												<button className="afs-gl-search__reclassify-confirm-btn afs-gl-search__reclassify-confirm-btn--all" onClick={function () { handleReclassify(tx, selectedTarget.canonical_code, selectedTarget.label, "rule"); }}>
													All matching
												</button>
												<button className="afs-gl-search__reclassify-confirm-btn afs-gl-search__reclassify-confirm-btn--cancel" onClick={() => { this.update({ selectedTarget: null }); }}>
													Cancel
												</button>
											</div>
										</div>
									)}
								</div>
							)}
						</div>
					);
				})}
				{filtered.length === 0 && search && (
					<div className="afs-gl-search__empty">No transactions match "{search}"</div>
				)}
			</div>
		</div>
	);
	}
}

export default GLSearchPanel;
